import React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Booking from "../components/booking/Booking";
export default () => {
  return (
    <Router>
      <Switch>
        <Route path="/book/now" component={Booking} />
      </Switch>
    </Router>
  );
};
